import React from 'react';
import { useSelector } from 'react-redux';

export const UserLayout = ({ children }) => {
    const { configUsuari } = useSelector(state => state);
    const municipio = configUsuari?.contingut;

    const fotoUrl = municipio?.foto_Mun
        ? `${process.env.REACT_APP_DOMINI_UPLOAD_CIUDAD}/${municipio.foto_Mun}`
        : null;

    return (
        <>
            <div className="ul-hero">
                {fotoUrl && <img src={fotoUrl} alt={municipio?.nombre_Mun} className="ul-hero-img" />}
                <div className="ul-hero-overlay" />
                <div className="ul-hero-content">

                    <div className="ul-hero-avatar">
                        {fotoUrl ? <img src={fotoUrl} alt={municipio?.nombre_Mun} /> : '🏙️'}
                    </div>

                    <div className="ul-hero-info">
                        <div className="ul-hero-tag">Municipio</div>
                        <h1 className="ul-hero-name">{municipio?.nombre_Mun ?? '—'}</h1>

                        <div className="ul-hero-chips">
                            {municipio?.cp_Mun && (
                                <span className="ul-hero-chip">📍 CP {municipio.cp_Mun}</span>
                            )}
                            {municipio?.habitantes_Mun && (
                                <span className="ul-hero-chip">
                                    👥 {Number(municipio.habitantes_Mun).toLocaleString('es-ES')} hab.
                                </span>
                            )}
                            {municipio?.pagWeb_Mun && (
                                <span className="ul-hero-chip">
                                    🌐 <a
                                        href={municipio.pagWeb_Mun.startsWith('http') ? municipio.pagWeb_Mun : `https://${municipio.pagWeb_Mun}`}
                                        target="_blank" rel="noreferrer"
                                    >
                                        {municipio.pagWeb_Mun.replace(/^https?:\/\//, '')}
                                    </a>
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="ul-body">
                {children}
            </div>
        </>
    );
};